"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.KodenTextField = void 0;
const React = __importStar(require("react"));
const react_1 = require("react");
const material_1 = require("@mui/material");
const usePrevious_1 = __importDefault(require("./hooks/usePrevious"));
exports.KodenTextField = (0, react_1.forwardRef)(({ id, outlined = false, disabled = false, placeholder = "", label = "", readOnly = false, multiline = false, margin = "dense", rows, error, autoFocus = false, value, defaultValue, inputRef: propsInputRef, onChange, onBlur, onEnter, onClick, inputProps = {}, type = "text", className, style, }, ref) => {
    const preDefaultValue = (0, usePrevious_1.default)(defaultValue);
    const theRef = (0, react_1.useRef)();
    const inputRef = propsInputRef || theRef;
    const isComposing = React.useRef(false);
    const materialTextFieldProps = {
        className,
        style,
        margin,
        id,
        type,
        autoFocus,
        disabled,
        placeholder,
        inputRef,
        multiline,
        rows: multiline ? rows : 0,
        fullWidth: true,
        InputProps: Object.assign(Object.assign({}, inputProps), { readOnly }),
        onCompositionStartCapture() {
            isComposing.current = true;
        },
        onCompositionUpdateCapture() {
            isComposing.current = true;
        },
        onCompositionEndCapture() {
            isComposing.current = false;
        },
        error: error !== "",
        helperText: error
    };
    if (label === undefined || label === "") {
        materialTextFieldProps.hiddenLabel = true;
    }
    else {
        materialTextFieldProps.label = label;
    }
    if (value !== undefined) {
        materialTextFieldProps.value = (value === null) ? "" : value;
    }
    if (defaultValue !== undefined) {
        materialTextFieldProps.defaultValue = (defaultValue === null) ? "" : defaultValue;
    }
    if (onBlur !== undefined) {
        materialTextFieldProps.onBlur = (event) => {
            onBlur(event.target.value, event);
        };
    }
    if (onChange !== undefined) {
        materialTextFieldProps.onChange = (e) => {
            onChange(e.target.value, e);
        };
    }
    if (onEnter !== undefined) {
        materialTextFieldProps.onKeyPress = (e) => {
            if (e.key === "Enter" && inputRef.current) {
                // @ts-ignore
                onEnter(inputRef.current.value);
            }
        };
    }
    if (onClick !== undefined) {
        materialTextFieldProps.onClick = (e) => {
            // @ts-ignore
            onClick(e.target.value, e);
        };
    }
    if (preDefaultValue !== defaultValue && inputRef && inputRef.current) {
        // @ts-ignore
        inputRef.current.value = defaultValue;
    }
    // @ts-ignore
    materialTextFieldProps.variant = outlined ? "outlined" : "standard";
    // @ts-ignore
    return React.createElement(material_1.TextField, Object.assign({}, materialTextFieldProps, { ref: ref }));
});
exports.default = exports.KodenTextField;
//# sourceMappingURL=koden-text-field.js.map